import { array, struct } from 'io-ts/Decoder';

//import { FilterRequestColumn } from './FilterRequestColumn';
import { Id as ClientId } from '../../client/Id';
export const FilterRequest = struct({
	client: array(ClientId),
});
